import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDioApproverNewHireCoverageEnrollment, getNewHireCoverageEnrollment } from '../../../../../global/ducks/mlps-api';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { setCoverageFormError, setNewHireEnrollmentCoverage } from '../slice/new-hire-enrollment-slices';
import { getPendingEnrollmentLocalStorage } from '../member/benefit-enrollment/helper/diocese-approver-coverage-helper';


export function useNewHireEnrollmentCoverage(employeeId: string, employerId: string, queryString: string, isDioApprover: boolean, eventType: string) {
	const localStoragePendingEnrollment = getPendingEnrollmentLocalStorage();
	const loaded = useSelector<TcsmStates, boolean>(state => state.newHireEnrollmentState?.newHireCoverageLoaded);
	const formID = useSelector<TcsmStates, number>(state => state.newHireEnrollmentState?.dioApproverCurrentFormId ?? localStoragePendingEnrollment?.id);
	const dispatch = useDispatch();

	useEffect(() => {

		if (!loaded) {
			if (!isDioApprover) {
				dispatch(getNewHireCoverageEnrollment(
					employeeId,
					queryString,
					employerId,
					eventType,
					(response) => dispatch(setNewHireEnrollmentCoverage(response?.data)),
					() => dispatch(setCoverageFormError()),
				));
			}
			if (isDioApprover) {
				dispatch(getDioApproverNewHireCoverageEnrollment(employeeId ?? localStoragePendingEnrollment?.employee?.guid, formID, (response) => {
					dispatch(setNewHireEnrollmentCoverage(response?.data));
				}, () => dispatch(setCoverageFormError()),
				));
			}
		}

	}, [employerId]);

	return loaded;
}